import AttentionIcon from '@components/icons/InlineAttention.svg';
import { CellContent } from './styles/CellContent';
import { TProps } from './types/TProps';

export const InlineEditRow = ({ data }: TProps) => {
  if (!data?.pipelineErrorMessage) {
    return null;
  }

  return (
    <tr className="no-border">
      <td></td>
      <td colSpan={100}>
        <CellContent>
          <AttentionIcon />
          Error: {data?.pipelineErrorMessage}
        </CellContent>
      </td>
    </tr>
  );
};
